module.exports = __webpack_public_path__ + "static/media/canada.9e5f3ce3.svg";